import type { UseIntl } from '../../../types';
import type { FieldErrorsTypes } from './types';

import { validatePassword, validateConfirmPassword } from '../Registration/validators';

interface Payload {
  newPassword: string;
  confirmPassword: string;
}

/**
 * Validates the password reset form fields.
 *
 * @param {Payload} payload - The form fields to validate.
 * @param {UseIntl} intl - React Intl object for localization of error messages.
 * @returns {FieldErrorsTypes} An object containing validation error messages for each field.
 *
 * Validation rules:
 * - `new_password` is required and must be at least 8 characters long.
 * - `confirm_password` is required, must be at least 8 characters, and must match `new_password`.
 */
export const validateFormFields = (
  payload: Payload,
  intl: UseIntl,
): FieldErrorsTypes => {
  const { newPassword, confirmPassword } = payload;
  const fieldErrors: FieldErrorsTypes = {};

  fieldErrors.new_password = validatePassword(intl, newPassword);
  fieldErrors.confirm_password = validateConfirmPassword(intl, newPassword, confirmPassword);

  return fieldErrors;
};
